import { render, staticRenderFns } from "./SectionInfection.vue?vue&type=template&id=8d5fefc2"
import script from "./SectionInfection.vue?vue&type=script&lang=ts"
export * from "./SectionInfection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports